import React from 'react'
import clsx from 'clsx'
import { useAppSelector } from '../../app/useAppSelector'

export const ConnectionBanner: React.FC = () => {
  const status = useAppSelector(s => s.rtls.connectionStatus)
  if (status === 'connected') return null

  const text =
    status === 'reconnecting' ? 'Reconnecting…' : 'Disconnected — check network'
  const cls =
    status === 'reconnecting'
      ? 'bg-statusYellow/20 text-statusYellow animate-pulse'
      : 'bg-statusRed/20 text-statusRed'

  return (
    <div
      className={clsx('flex items-center justify-center px-lg py-xs text-xs font-semibold', cls)}
      role="status"
    >
      {text}
    </div>
  )
}
